/**
 * This file is part of DNG
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 *
 * @author Nicolò Martini <nicmartnic@gmail.com>
 */

/**
 * This module defines dom events to semantic events mapping for shelf-related events.
 */
define('dng-shelves-dom',["jquery", "dng-common", "dng-shelves"], function($, dng) {

    $(document).ready(function()
    {
        /**
         * Dom events to semantic events mapping
         */
        $('body').on('click', '.in_shelves .remove-from-shelf', function(event){
            event.preventDefault();
            changeLoadingState($(this), 1);
            $(this).text('');
            $(this).trigger('shelf-update-request', [$(this).closestData('shelfid'), $(this).closestData('manid'), false]);
        });

        $('body').on('click', '.shelf-edit, .shelf-create', function(event) {
            event.preventDefault();
            $(this).trigger('shelf-dialog-requested', [$(this).closestData('shelf-id')]);
        });

        $('body').on('click', '.shelf-edit-dialog .confirm-modal', function(event){
            event.preventDefault();
            var modal = $(this).closest('.modal');
            var args = modal.find('form').toHash();
            $(this).trigger('shelf-edit-request',
                [args.id || 0, args.name, args.description, args.visibility]);
            modal.modal("hide");
        });

        $('body').on('click', '#save-search-dialog .confirm-modal', function(event){
            event.preventDefault();
            var formArgs = $("#save-search-dialog form").toHash();
            $(this).trigger('save-search-request', [formArgs]);
            $("#save-search-dialog").modal("hide");
            $("#save-search-dialog").remove();
        });


        $('body').on('modal-hidden', '.dropdown-menu .create-shelf-btn', function(e) {
            $(this).closest('.add-to-shelf').addClass('open');
        });

        $('body').on('change', 'input.shelfship-checkbox', function()
        {
            var checkbox = $(this);
            var newValue = checkbox.is(":checked");

            changeLoadingState(checkbox.closest('label'), true);

            $(this).trigger('shelf-update-request', [
                checkbox.closestData('shelfid'),
                checkbox.closestData('manid'),
                newValue
            ]);
        });

        /**
         * Dom-specific handlers for semantic events
         */
        $('body').on('shelf-updated', function(event, shelfid, manifestationid, state)
        {
            $('.in_shelves[data-manid="' + manifestationid + '"]').trigger('refresh');
        });

        $('body').on('shelf-updated', function(event, shelfid, manifestationid, state)
        {
            var checkbox = $('*[data-manid="' + manifestationid + '"] *[data-shelfid="'+ shelfid + '"] input.shelfship-checkbox');

            if (checkbox.prop('checked') != state)
                checkbox.prop('checked', !checkbox.prop('checked'));

            changeLoadingState(checkbox.closest('label'), false);
        });

        $('body').on('shelf-created', function(event, shelfId) {
            $.get('shelf/checkbox', {id: shelfId}).done(function(checkboxHtml){
                var $checkbox= $(checkboxHtml);
                $('.shelves-checkboxes li.divider').before($checkbox);
                $checkbox.highlight();
            });

            $.get('shelf/selectOption', {id: shelfId}).done(function(optionHtml){
                $('#member_shelf_id').append(optionHtml);
            });
        });
    });

    var changeLoadingState = function(element, state) {
        if (state) {
            $(element).attr('data-isloading', 1);
        } else {
            $(element).removeAttr('data-isloading');
        }
    };
});

